export default "__VITE_ASSET__BLYTAk10__"